<template>
  <div>
    <el-select :value="status" value-key="key" :size="size" :placeholder="$t('table.status')" @input="change($event)" :clearable="true">
      <el-option label="处理中" value="0" />
      <el-option label="成功" value="1" />
      <el-option label="失败" value="2" />
    </el-select>
  </div>
</template>

<script>
export default {
  data () {
    return {
      status: 0
    }
  },
  props: ['value', 'size', 'showAllTip', 'showAllTipLabel'],
  methods: {
    change: function (val) {
      this.status = val
      this.$emit('input', this.status)
    }
  },
  mounted () {
    this.status = this.value
  },
  watch: {
    value: function (val, oldVal) {
      this.status = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/card/components/OrderStateSelect.vue